export class EnvironmentService {
  constructor() {}

  async init(coords, cb) {
    const rIris = await this.getIris(coords);
    if (rIris) {
      this.iris = rIris;
      return { iris: this.iris };
    } else {
      return null;
    }
  }

  async getIris(coords) {
    let path = "https://geo.data.homeinlove.fr/env/geoinfo/iris/";
    path += coords[0] + "/" + coords[1];
    const resp = await fetch(path);
    const mResp = await resp.json();
    const out = [];
    mResp.forEach(e => {
      if (e.properties.iris && e.properties.depcom) {
        out.push(e);
      }
    });
    return out;
  }

  getPolygon(iris) {
    return {
      type: iris.geometry.type,
      coordinates: iris.geometry.coordinates
    };
  }

  async getData(iris) {
    let path = "https://geo.data.homeinlove.fr/env/geoinfo/dataIris/";
    path += iris.properties.depcom + iris.properties.iris;
    const resp = await fetch(path);
    const mResp = await resp.json();
    return mResp[0];
  }

  async getIrisMainInfos(iris) {
    let irisMainInfos;
    const housing = [];
    const shop = [];
    const schools = [];
    const relax = [];
    const health = [];
    const utils = [];
    const dataIris = await this.getData(iris);
    housing.push({
      title: "Nombre d'habitants",
      value: Number(dataIris.P12_POP).toPrecision(5)
    });
    housing.push({
      title: "Nombre de ménages",
      value: Number(dataIris.C12_MEN).toPrecision(5)
    });
    housing.push(
      this.getPrimaryFromList({
        "Nombre de personnes de 15 ans ou plus Agriculteurs exploitants":
          dataIris.C12_POP15P_CS1,
        "Nombre de personnes de 15 ans ou plus Artisans, Commerçants, Chefs d'entreprise":
          dataIris.C12_POP15P_CS2,
        "Nombre de personnes de 15 ans ou plus Cadres et Professions intellectuelles supérieures":
          dataIris.C12_POP15P_CS3,
        "Nombre de personnes de 15 ans ou plus Professions intermédiaires":
          dataIris.C12_POP15P_CS4,
        "Nombre de personnes de 15 ans ou plus Employés":
          dataIris.C12_POP15P_CS5,
        "Nombre de personnes de 15 ans ou plus Ouvriers":
          dataIris.C12_POP15P_CS6,
        "Nombre de personnes de 15 ans ou plus Retraités":
          dataIris.C12_POP15P_CS7,
        "Nombre de personnes de 15 ans ou plus Autres sans activité professionnelle":
          dataIris.C12_POP15P_CS8
      })
    );
    housing.push({
      title: "Nombre de logements",
      value: Number(dataIris.P11_LOG).toPrecision(5)
    });
    housing.push({
      title: "Nombre de maisons",
      value: Number(dataIris.P11_MAISON).toPrecision(5)
    });
    housing.push({
      title: "Nombre d'appartements",
      value: Number(dataIris.P11_APPART).toPrecision(5)
    });
    housing.push({
      title: "Nombre de résidences principales occupées par propriétaires",
      value: Number(dataIris.P11_RP_PROP).toPrecision(5)
    });
    housing.push({
      title: "Nombre de résidences principales occupées par locataires",
      value: Number(dataIris.P11_RP_LOC).toPrecision(5)
    });

    shop.push({
      title: "Hypermarché, Supermarché",
      value: this.addValues([dataIris.NB_B101_x, dataIris.NB_B102_x])
    });
    shop.push({
      title: "Supérette, Epicerie, Produits surgelés",
      value: this.addValues([
        dataIris.NB_B201_x,
        dataIris.NB_B202_x,
        dataIris.NB_205_x
      ])
    });
    shop.push({ title: "Boulangerie", value: dataIris.NB_B203_x });
    shop.push({
      title: "Boucherie charcuterie",
      value: dataIris.NB_B204_x
    });
    shop.push({ title: "Poissonnerie", value: dataIris.NB_B206_x });
    shop.push({ title: "Tabac presse", value: dataIris.NB_B301_x });
    shop.push({
      title:
        "Magasin de vêtements, Magasin de chaussures, Magasin d'articles de sports et de loisirs",
      value: this.addValues([
        dataIris.NB_B302_x,
        dataIris.NB_B304_x,
        dataIris.NB_307_x
      ])
    });
    shop.push({
      title: "Magasin d'équipements du foyer",
      value: this.addValues([
        dataIris.NB_B303_x,
        dataIris.NB_B305_x,
        dataIris.NB_306_x,
        dataIris.NB_308_x,
        dataIris.NB_309_x
      ])
    });
    shop.push({
      title: "Bureau de poste, Relais poste, Agence postale ",
      value: this.addValues([
        dataIris.NB_A206_x,
        dataIris.NB_A207_x,
        dataIris.NB_A208_x
      ])
    });

    schools.push({ title: "Nombre de crèches", value: dataIris.NB_D501 });
    schools.push({
      title: "Nombre d'écoles primaires",
      value: dataIris.NB_C104
    });
    schools.push({ title: "Nombre de collèges", value: dataIris.NB_C201 });
    schools.push({
      title: "Nombre de lycées",
      value: this.addValues([dataIris.NB_C301, dataIris.NB_C302])
    });
    schools.push({
      title: "Nombre d'universités",
      value: this.addValues([
        dataIris.NB_C502,
        dataIris.NB_C503,
        dataIris.NB_C504,
        dataIris.NB_C509
      ])
    });

    relax.push({
      title: "Nombre de restaurants / bars",
      value: dataIris.NB_A504_x
    });
    relax.push({
      title: "Nombre d'activité sportive",
      value: this.addValues([
        dataIris.NB_F101,
        dataIris.NB_F102,
        dataIris.NB_F103,
        dataIris.NB_F104,
        dataIris.NB_F105,
        dataIris.NB_F106,
        dataIris.NB_F107,
        dataIris.NB_F108,
        dataIris.NB_F109,
        dataIris.NB_F110,
        dataIris.NB_F111,
        dataIris.NB_F112,
        dataIris.NB_F113,
        dataIris.NB_F114,
        dataIris.NB_F115,
        dataIris.NB_F116,
        dataIris.NB_F117,
        dataIris.NB_F118,
        dataIris.NB_F201,
        dataIris.NB_F203
      ])
    });
    relax.push({
      title: "Nombre de cinéma, théâtre",
      value: this.addValues([dataIris.NB_F301, dataIris.NB_F302])
    });

    health.push({ title: "Pharmacie", value: dataIris.NB_D301_x });
    health.push({
      title: "Nombre d'équipements lié à la santé",
      value: this.addValues([
        dataIris.NB_D106_x,
        dataIris.NB_D107_x,
        dataIris.NB_D108_x,
        dataIris.NB_D109_x,
        dataIris.NB_D110_x
      ])
    });

    utils.push({
      title: "Nombre de bâtiments administratif",
      value: this.addValues([
        dataIris.NB_A101_x,
        dataIris.NB_A104_x,
        dataIris.NB_A105_x,
        dataIris.NB_A106_x,
        dataIris.NB_A107_x,
        dataIris.NB_A108_x,
        dataIris.NB_A109_x
      ])
    });

    irisMainInfos = {
      housing: housing,
      shop: shop,
      schools: schools,
      relax: relax,
      health: health,
      utils: utils
    };

    return irisMainInfos;
  }

  getPrimaryFromList(list) {
    const arr = Object.keys(list).map(function(key) {
      return Number(list[key]);
    });
    const primaryElementIndex = arr.indexOf(Math.max.apply(Math, arr));
    return {
      title: Object.keys(list)[primaryElementIndex],
      value: Number(list[Object.keys(list)[primaryElementIndex]]).toPrecision(5)
    };
  }

  addValues(values) {
    let res = 0;
    let val;
    for (let i = 0; i < values.length; i++) {
      if (isNaN((val = Number(values[i]))) === true) {
        val = 0;
      }
      res += val;
    }
    return res;
  }
}
